var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-0"},[_c('img',{attrs:{"src":(_vm.$assetsEndpoint + "/studio-footer.png"),"width":"100%","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }